import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { SvgComponent } from '@app/base-components';
import { ButtonQaId, HabaQaId } from '@app/helpers';
import { CloudinaryService } from '@app/services';
import { I18nModule, UrlModule } from 'haba-core';
import {
  CheckoutProgressComponent as CxCheckoutProgressComponent,
  CheckoutStepService,
} from 'haba-featurelibs/checkout/components';

@Component({
  selector: 'app-checkout-progress',
  templateUrl: './checkout-progress.component.html',
  styleUrls: ['./checkout-progress.component.scss'],
  imports: [NgIf, RouterLink, NgFor, SvgComponent, AsyncPipe, I18nModule, UrlModule],
})
export class CheckoutProgressComponent extends CxCheckoutProgressComponent implements OnInit {
  stepButtonId: ButtonQaId;

  wehrfritzLogoPupId = '/wehrfritz/mainsources/logos/Wehrfritz_Logo.svg';
  wehrfritzLogoWidth = 325;
  wehrfritzLogoHeight = 80;
  wehrfritzLogoSrc: string;

  constructor(
    checkoutStepService: CheckoutStepService,
    private router: Router,
    private cloudinaryService: CloudinaryService
  ) {
    super(checkoutStepService);
  }

  ngOnInit(): void {
    this.wehrfritzLogoSrc = this.cloudinaryService.cloudinary
      .image(this.wehrfritzLogoPupId)
      .toURL();
    const baseId = HabaQaId.forPage(HabaQaId.page.header);
    this.stepButtonId = baseId.getButtonId(HabaQaId.elements.button.checkout);
  }

  authorizedPayment() {
    return this.router.url.includes('authorize-payment');
  }
}
